var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('h2',[_vm._v("欢迎访问德辛捷承包商HSE培训平台后台管理系统")])])}]

export { render, staticRenderFns }